import { quiz as EnUsQuiz } from '../en-us/quiz';

export const quiz = {
  ...EnUsQuiz,
  valueChart: {
    ...EnUsQuiz.valueChart,
    tableHead1: 'AG1 kann ersetzen',
    tableHead2: 'Kosten pro Monat',
    chartConfig: [
      { title: 'Multivitamin & Mineralstoffe', value: 45 },
      { title: 'Probiotikum', value: 30 },
      { title: 'Superfoods', value: 50 },
      { title: 'Stress-Adaptogen', value: 30 },
      { title: 'Immunsystem-Unterstützung', value: 40 },
      { title: 'Kognitive Unterstützung', value: 30 }
    ],
    tableFooter: 'Gesamt pro Monat',
    caption:
      'Basierend auf aktuell verfügbaren Daten zu den durchschnittlichen Branchenpreisen für Premium-Nahrungsergänzungsmittel'
  }
};
